
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/daymade-x-much-better-adventures",
      function () {
        return require("private-next-pages/blog/daymade-x-much-better-adventures.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/daymade-x-much-better-adventures"])
      });
    }
  